import './LanguageSelect.css';
import { useSelector } from 'react-redux';
import { useBetween } from 'use-between';

function LanguageSelect() {
    const { setLocale } = useBetween(useSelector(state => state.useSharedLang));
    const changeLang = (e) => {
        setLocale(e.target.value)
    }

    return (
        <div>
            <select
                className="selectBoxLang"
                onChange={changeLang}
                name="lang"
            >

                <option className="optionsMenu" value="AR" >
                    العربيّة
                </option>
                <option className="optionsMenu" value="EN">
                    English
                </option>
                <option className="optionsMenu" value="OR" >
                    اردو
                </option>
                <option className="optionsMenu" value="HN">
                    हिन्दी
                </option>

            </select>
        </div>
    );
}

export default LanguageSelect;
